import Dog from "./SVG/dog.svg?react";

const DogIcon = () => {
  return <Dog />;
};

export default DogIcon;
